const pesticidesList = [
    {
        "id": "hasere1",
        "name": "Alfa SC",
        "image": "https://cdn.dsmcdn.com/ty371/product/media/images/20220325/17/75940162/142509968/1/1_org_zoom.jpg",
        "info": ""
    },
    {
        "id": "hasere2",
        "name": "Chrysa Fibron Jel",
        "image": "https://chrysamedonline.com/wp-content/uploads/2023/01/fibron-jel-35gr-chrysamedonline-1-600x600.jpg",
        "info": ""
    },
    {
        "id": "hasere3",
        "name": "K-Otrine",
        "image": "https://productimages.hepsiburada.net/s/81/375/110000023524721.jpg",
        "info": "SC 50"
    },
    {
        "id": "hasere4",
        "name": "Icon",
        "image": "https://productimages.hepsiburada.net/s/38/550/10585085673522.jpg/format:webp",
        "info": "10 CS"
    },
    {
        "id": "hasere5",
        "name": "Fatox",
        "image": "https://static.ticimax.cloud/38051/uploads/urunresimleri/buyuk/fatox-hazir-solusyon-500-ml-a-4597.jpg",
        "info": "10 CS"
    },
    {
        "id": "hasere6",
        "name": "Maxforce",
        "image": "https://productimages.hepsiburada.net/s/28/375/10236520792114.jpg",
        "info": "Jel"
    },
    {
        "id": "hasere7",
        "name": "Rodilon Paste",
        "image": "https://cdn.akakce.com/z/bayer/bayer-rodilon-paste-10-gr-10-lu.jpg",
        "info": "EC 50"
    },
    {
        "id": "hasere8",
        "name": "Tibtrap",
        "image": "https://productimages.hepsiburada.net/s/36/375/10518988521522.jpg",
        "info": "10 CS"
    },
   
]

export default pesticidesList; 